import { Controller } from '@hotwired/stimulus';

/**
 * Stimulus Controller para InputText
 *
 * Gerencia comportamentos e interações básicas de campos de texto genéricos.
 */
export default class extends Controller {
    connect() {
        this.inputElement = this.element.querySelector('input') || this.element;
        // Adicione comportamentos comuns do InputText aqui se necessário
    }
}
